import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faMobile, faXmark } from '@fortawesome/pro-solid-svg-icons';
import { cn } from '@ver.id/libs.ui.charlie';

export type AppLogoBadgeKind = 'phone' | 'check' | 'x';

const BADGES: Record<
  AppLogoBadgeKind,
  { icon: typeof faCheck; className: string }
> = {
  phone: {
    icon: faMobile,
    className: 'bg-muted-foreground text-card [&>svg]:animate-embedded-rise',
  },
  check: { icon: faCheck, className: 'bg-emerald-500 text-white' },
  x: { icon: faXmark, className: 'bg-destructive text-white' },
};

/**
 * AppLogoBadge — The marker on an AppLogo's corner: a rising phone (continue
 * in the app), a check (done) or a cross (didn't finish).
 */
export default function AppLogoBadge({ kind }: { kind: AppLogoBadgeKind }) {
  const { icon, className } = BADGES[kind];
  return (
    <span
      aria-hidden="true"
      className={cn(
        'inline-flex size-[22px] items-center justify-center overflow-hidden rounded-full border-2 border-card text-[11px]',
        className,
      )}
    >
      <FontAwesomeIcon icon={icon} />
    </span>
  );
}
